const API_URL = "https://api.zintunes.com";
const FILE_URL = "https://api.zintunes.com/assets/files";


// const API_URL = "http://localhost:5001";
// const FILE_URL = "http://localhost:5001/assets/files";


export { API_URL, FILE_URL }
